import RemoveButton from './RemoveButton'

export default RemoveButton



// WEBPACK FOOTER //
// ./src/components/RemoveButton/index.js